import axios from 'axios';
import config from "../../config";
import { headers_get } from "../../main_components/tokens/get_headers_user";

const BASE_URL = `${config?.URL_CONFIGURATION}`;

const request = async (method, endpoint, data = null) => {
    const url = `${BASE_URL}${endpoint}`;
    try {
        const headers = await headers_get();
        return await axios({ method, url, data, headers });
    } catch (error) {
        console.error(`Error in ${method.toUpperCase()} ${url}:`, error?.response?.data || error.message);
        throw error;
    }
};

export const company_get = () => request("get", "/od/company");

export const company_put = (data) => request("put", "/od/company", data);

export const company_address_get = () => request("get", "/od/company/address");

export const company_address_put = (data) => request("put", "/od/company/address", data);